import { useId } from 'react';
import { SETTLEMENT_OPTIONS, EVIDENCE_OPTIONS_BY_GAME } from '../constants/verificationEvidence';
import './VerificationPlanSection.css';

/**
 * Creator chooses settlement path + optional dispute-prep tools at challenge creation.
 */
export default function VerificationPlanSection({
  gameId,
  settlement,
  onSettlementChange,
  evidenceTips,
  onEvidenceTipsChange,
}) {
  const gid = Number(gameId);
  const options = EVIDENCE_OPTIONS_BY_GAME[gid] || [];
  const baseId = useId();

  const toggleEvidence = (id) => {
    const next = evidenceTips.includes(id)
      ? evidenceTips.filter((x) => x !== id)
      : [...evidenceTips, id];
    onEvidenceTipsChange(next);
  };

  return (
    <section className="verification-plan-section" aria-labelledby={`${baseId}-heading`}>
      <h4 id={`${baseId}-heading`} className="verification-plan-title">
        How should we verify the winner?
      </h4>
      <p className="verification-plan-lead">
        Choose what happens after you play. You can change your mind about recording tools anytime—these checkboxes
        only help EWIO show the right guides on your challenge page.
      </p>

      <fieldset className="verification-plan-fieldset">
        <legend className="verification-plan-legend">Settlement</legend>
        {SETTLEMENT_OPTIONS.map((opt) => (
          <label key={opt.value} className="verification-plan-radio-card">
            <input
              type="radio"
              name={`settlement-${baseId}`}
              value={opt.value}
              checked={settlement === opt.value}
              onChange={() => onSettlementChange(opt.value)}
            />
            <span className="verification-plan-radio-body">
              <span className="verification-plan-radio-title">{opt.title}</span>
              <span className="verification-plan-radio-desc">{opt.description}</span>
            </span>
          </label>
        ))}
      </fieldset>

      {options.length > 0 && (
        <div className="verification-plan-evidence">
          <h5 className="verification-plan-subtitle">Optional: tools for proof if there is a disagreement</h5>
          <p className="verification-plan-evidence-hint">
            Tick anything you might use so we can show install links and short steps on the challenge. This does not
            upload files to EWIO.
          </p>
          <ul className="verification-plan-evidence-list">
            {options.map((opt) => (
              <li key={opt.id}>
                <label className="verification-plan-check-row">
                  <input
                    type="checkbox"
                    checked={evidenceTips.includes(opt.id)}
                    onChange={() => toggleEvidence(opt.id)}
                  />
                  <span className="verification-plan-check-label">{opt.label}</span>
                </label>
                <p className="verification-plan-check-blurb">{opt.blurb}</p>
                <ul className="verification-plan-link-list">
                  {opt.links.map((link) => (
                    <li key={link.href}>
                      <a href={link.href} target="_blank" rel="noopener noreferrer">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
